import React from "react";
import "./Incident.css";
import TarjetaDeServicio from "./components/TarjetaDeServicioIncident";
import GestionIncident from "./components/GestionIncident";
import { useTranslation } from "react-i18next";

interface ServiceItem {
  title: string;
  desc: string;
}

export default function Incident() {
  const { t } = useTranslation();

  const services: ServiceItem[] = [
    {
      title: t("pages.incident.services.0.title"),
      desc: t("pages.incident.services.0.desc"),
    },
    {
      title: t("pages.incident.services.1.title"),
      desc: t("pages.incident.services.1.desc"),
    },
    {
      title: t("pages.incident.services.2.title"),
      desc: t("pages.incident.services.2.desc"),
    },
  ];

  return (
    <>
      <section
        className="fondo-incident"
        style={{
          backgroundImage: 'url("/incidentmanagement.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        } as React.CSSProperties}
      >
        <div className="incident-overlay">
          <h1 className="incident-titulo">{t("pages.incident.title")}</h1>
          <p className="incident-descripcion">
            {t("pages.incident.description")}
          </p>
        </div>
      </section>

      <h2 className="incident-subtitulo">
        {t("pages.incident.benefits_title")}
      </h2>

      <div className="incident-card-grid">
        {services.map((service, index) => (
          <TarjetaDeServicio
            key={index}
            service={service}
            animationClass="from-bottom"
            delay={index * 0.2}
          />
        ))}
      </div>

      <GestionIncident
        gestion={[
          {
            titulo: t("pages.incident.gestion.0.titulo"),
            descripcion: t("pages.incident.gestion.0.descripcion"),
          },
          {
            titulo: t("pages.incident.gestion.1.titulo"),
            descripcion: t("pages.incident.gestion.1.descripcion"),
          },
          {
            titulo: t("pages.incident.gestion.2.titulo"),
            descripcion: t("pages.incident.gestion.2.descripcion"),
          },
          {
            titulo: t("pages.incident.gestion.3.titulo"),
            descripcion: t("pages.incident.gestion.3.descripcion"),
          },
        ]}
        alcance={[
          { titulo: t("pages.incident.alcance.0.titulo") },
          { titulo: t("pages.incident.alcance.1.titulo") },
          { titulo: t("pages.incident.alcance.2.titulo") },
          { titulo: t("pages.incident.alcance.3.titulo") },
        ]}
      />
    </>
  );
}
